export default {
    getFilters: (state, rootGetters) => {
        return {
            reportColumns: state.reportColumns,
            filters: state.filters,
            advancedFilters: state.advancedFilters,
            pagination: {
                limit: state.paginationLimit,
                pagination: state.pagination
            },
            search: state.searchPhrase,
            sort: rootGetters.getSortColumn
        }
    },

    getFilterValueByFilterName: state => (filterName) => {
        if (typeof state.filters[filterName] !== 'undefined')
        {
            return state.filters[filterName];
        }

        return [];
    },

    getPagination: state => {
        return {
            limit: state.paginationLimit,
            pagination: state.pagination,
        }
    },

    getPaginationLimit: state => {
        return state.paginationLimit;
    },
    getReportColumns: state => {
        return state.reportColumns;
    },
    getDefaultOrderedColumn: state => {
        return state.reportColumns.find(item => item.defaultSorting)
    },
    getUpdatingStatus: state => {
        return state.isNeedToUpdate;
    },
    getLoadingStatus: state => {
        return state.loadingStatus > 0;
    },
    isPresetUpdated: state => {
        return state.presetUpdated;
    },

    isDatesComparisonEnabled: state => {
        return state.dateComparisonStatus;
    },
    getChartUpdatingStatus: state => {
        return state.isNeedToUpdateChart;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/filter/getters.js